<div style="
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: space-between;
    margin-bottom: 10px;
  ">
  <div class="batch-select">
    <div style="display:flex; flex-direction: row; gap: 10px; align-items:baseline">
      <mat-form-field appearance="fill" [style.min-width.px]="450">
        <mat-label>Select batch</mat-label>

        @if (batches.isLoading()) {
        <mat-select disabled>
          <mat-option>Loading…</mat-option>
        </mat-select>
        }

        @if (batches.error()) {
        <mat-select disabled>
          <mat-option>Error loading batches</mat-option>
        </mat-select>
        }

        @if (batches.value(); as batches) {
        <mat-select [formControl]="batchSelectControl">
          @for (b of batches; track b.id) {
          @if (!hideEmptyBatches() || b.unprocessedCount > 0) {
          <mat-option [value]="b">{{ b.name }} ({{
            b.uploadedOn | isoStringToDate: "date"
            }}) - {{b.unprocessedCount}} items remaining</mat-option>
          }
          }
        </mat-select>
        }
        <mat-hint>Select an import batch to process</mat-hint>
      </mat-form-field>

      <button matIconButton class="n-delete-button" (click)="deleteBatch()" [disabled]="!batch || !authService.isActualAdmin"
        matTooltip="Delete the entire batch, including all included items. This action cannot be undone.">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    <div>
      <mat-checkbox [checked]="hideEmptyBatches()" (change)="hideEmptyBatches.set($event.checked)">
        Hide empty batches
      </mat-checkbox>
    </div>
  </div>

  <div class="batch-select" style="justify-content: flex-end">
    <mat-card appearance="outlined">
      <mat-card-content style="padding: 5px; display: flex; flex-direction: column;">
        <div class="summary-flex">
          <!-- LEFT COLUMN -->
          <div class="column">
            <div class="row">
              <span class="label mat-body-small">Uploaded by</span>
              <span class="value mat-body-medium">
                {{ batch?.uploadedBy || "\u00A0" }}
              </span>
            </div>
            <div class="row">
              <span class="label mat-body-small">Uploaded on</span>
              <span class="value mat-body-medium">
                {{
                batch?.uploadedOn
                ? (batch?.uploadedOn | isoStringToDate: "datetime")
                : "\u00A0"
                }}
              </span>
            </div>
            <div class="row">
              <span class="label mat-body-small">Unprocessed rows</span>
              <span class="value mat-body-medium">
                {{ batch?.unprocessedCount ?? "\u00A0" }}
              </span>
            </div>
          </div>

          <!-- RIGHT COLUMN -->
          <div class="column">
            <div class="row">
              <span class="label mat-body-small">Uploaded rows</span>
              <span class="value mat-body-medium">
                {{ batch?.validCount ?? "\u00A0" }}
              </span>
            </div>
            <div class="row">
              <span class="label mat-body-small">Invalid rows</span>
              <span class="value mat-body-medium">
                {{ batch?.invalidCount ?? "\u00A0" }}
              </span>
            </div>
          </div>
        </div>
        <div class="chip-row">
          <span class="label mat-body-small">Projects</span>
          <span class="value mat-body-medium">
            @if (batch?.projects) {
            <mat-chip-set>
              @for (v of batch?.projects ?? []; track v.id) {
              <mat-chip>{{ v.name }}</mat-chip>
              }
            </mat-chip-set>
            } @else {
            {{"\u00A0"}}
            }
          </span>
        </div>
        <div class="chip-row">
          <span class="label mat-body-small">Events</span>
          <span class="value mat-body-medium">
            @if (batch?.events) {
            <mat-chip-set>
              @for (v of batch?.events ?? []; track v.id) {
              <mat-chip>{{ v.name }}</mat-chip>
              }
            </mat-chip-set>
            } @else {
            {{"\u00A0"}}
            } </span>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<mat-divider style="padding-top: 10px"></mat-divider>

<div class="n-table-wrapper">
  @if (loading()) {
  <div class="n-spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
  }
  <div class="n-table-scroll" style="margin-top: 10px">
    <div class="import-list">
      @if (!batch) {
      <div class="empty-row">
        <span class="material-symbols-outlined n-warning-icon">step</span>
        Select a batch first.
      </div>
      } @else if (!batchLoaded()) {
      <div class="empty-row">
        <span class="material-symbols-outlined n-warning-icon">step</span>
        Load the batch items
      </div>
      } @else if (pagedData().length === 0) {
      <div class="empty-row">
        <span class="material-symbols-outlined n-info-icon">thumb_up</span>
        No more contacts to process. Well done!
      </div>
      } @else {
      @for (item of pagedData(); track item.uploadItem.id) {
      <app-contact-import [batchId]="batch!.id" [importItem]="item" (reloadRequested)="reloadItems()" />
      }
      }
    </div>

    <mat-paginator [length]="data().length" [pageSize]="pageSize()" [pageIndex]="pageIndex()"
      [pageSizeOptions]="[1, 5, 10, 20]" (page)="onPage($event)">
    </mat-paginator>
  </div>
</div>